<script setup lang="ts">
import type { PlanningBoardLocation } from "@/board/location/PlanningBoardLocation";
import SingleAriaElement from "@/components/ui/a11y/SingleAriaElement.vue";
import SkipButton from "@/components/ui/a11y/SkipButton.vue";
import type { ActionSource } from "@/model/action";
import type { Board } from "@/model/board";

defineProps<{ location: PlanningBoardLocation; board: Board }>();
const emit = defineEmits<{ overview: [PlanningBoardLocation, ActionSource?, string?] }>();
</script>

<template>
  <SingleAriaElement class="base-planning-board-section">
    <div v-owned-cards="{ board, location, tabindex: '-1' }" class="wrapper">
      <slot />
      <SkipButton
        :id="`overview-button-${location.left}-${location.top}`"
        class="overview-button"
        tabindex="-1"
        @click="
          emit(
            'overview',
            location,
            'keyboard',
            `#overview-button-${location.left}-${location.top}`,
          )
        "
      >
        {{ $t("label.planningBoard.seeOverviewButton") }}
      </SkipButton>
    </div>
  </SingleAriaElement>
</template>

<style lang="scss" scoped>
@use "@/styles/board";

.base-planning-board-section {
  .wrapper {
    width: 100%;
    height: 100%;
  }

  .overview-button.overview-button {
    position: absolute;
    padding: board.len(14px);
    border-radius: board.len(8px);
    font-size: board.len(12px);
    line-height: 1.2;

    :deep(> *) {
      height: unset;
    }
  }
}
</style>
